<template>
 <div>
<DeletionPolicy/>
<mobFooter />
 </div>
  
</template>

<script setup>
  import DeletionPolicy from '@/components/DeletionPolicy.vue';

 import mobFooter from "@/components/FooterAreaMobile.vue";
// export default {
//   name: "About-Us",
//   components: {
//     // Header,
//     // mobFooter,
//   },
// };
</script>

<style scoped>
.aboutus {
  padding: 70px 0 50px 0;
}
.textStyle {
  text-align: left;
}
.aboutus img {
  max-width: 100%;
}
.aboutus h2 {
  font-size: 55px;
  max-width: 100%;
  margin-bottom: 20px;
}
</style>
